import React, { useState } from 'react';
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  IconButton,
  Divider,
  Toolbar,
  Box,
} from '@mui/material';
import {
  ExpandLess,
  ExpandMore,
  Storage,
  Computer,
  NetworkCheck,
  MonetizationOn,
  Security,
  Menu,
  Dashboard,
  Layers,
} from '@mui/icons-material';

const drawerWidth = 220;

const Sidebar = ({ onNavigate, selectedSection, selectedSubsection }) => {
  const [open, setOpen] = useState(true);
  const [inventoryOpen, setInventoryOpen] = useState(true);

  const handleDrawerToggle = () => {
    setOpen((prev) => !prev);
  };

  const handleInventoryClick = () => {
    setInventoryOpen((prev) => !prev);
  };

  return (
    <Drawer
      variant="permanent"
      open={open}
      sx={{
        width: open ? drawerWidth : 60,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: open ? drawerWidth : 60,
          boxSizing: 'border-box',
          transition: 'width 0.2s',
          overflowX: 'hidden',
        },
      }}
    >
      <Toolbar>
        <Box sx={{ flexGrow: 1 }} />
        <IconButton onClick={handleDrawerToggle} size="small">
          <Menu />
        </IconButton>
      </Toolbar>
      <Divider />
      <List>
        <ListItemButton
          selected={selectedSection === 'dashboard'}
          onClick={() => onNavigate('dashboard')}
          sx={{ justifyContent: open ? 'flex-start' : 'center' }}
        >
          <ListItemIcon>
            <Dashboard />
          </ListItemIcon>
          {open && <ListItemText primary="Dashboard" />}
        </ListItemButton>
        <ListItemButton
          onClick={handleInventoryClick}
          selected={selectedSection === 'inventory'}
          sx={{ justifyContent: open ? 'flex-start' : 'center' }}
        >
          <ListItemIcon>
            <Layers />
          </ListItemIcon>
          {open && <ListItemText primary="Inventory" />}
          {open && (inventoryOpen ? <ExpandLess /> : <ExpandMore />)}
        </ListItemButton>
        <Collapse in={inventoryOpen && open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              sx={{ pl: 4 }}
              selected={selectedSubsection === 'vm'}
              onClick={() => onNavigate('inventory', 'vm')}
            >
              <ListItemIcon>
                <Computer />
              </ListItemIcon>
              <ListItemText primary="VM" />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: 4 }}
              selected={selectedSubsection === 'network'}
              onClick={() => onNavigate('inventory', 'network')}
            >
              <ListItemIcon>
                <NetworkCheck />
              </ListItemIcon>
              <ListItemText primary="Network" />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: 4 }}
              selected={selectedSubsection === 'disk'}
              onClick={() => onNavigate('inventory', 'disk')}
            >
              <ListItemIcon>
                <Storage />
              </ListItemIcon>
              <ListItemText primary="Disk" />
            </ListItemButton>
          </List>
        </Collapse>
        <ListItemButton
          selected={selectedSection === 'cost'}
          onClick={() => onNavigate('cost')}
          sx={{ justifyContent: open ? 'flex-start' : 'center' }}
        >
          <ListItemIcon>
            <MonetizationOn />
          </ListItemIcon>
          {open && <ListItemText primary="Cost Governance" />}
        </ListItemButton>
        <ListItemButton
          selected={selectedSection === 'gcr'}
          onClick={() => onNavigate('gcr')}
          sx={{ justifyContent: open ? 'flex-start' : 'center' }}
        >
          <ListItemIcon>
            <Security />
          </ListItemIcon>
          {open && <ListItemText primary="GCR" />}
        </ListItemButton>
      </List>
    </Drawer>
  );
};

export default Sidebar; 